import HotPairColorOptions from "./HotPairColorOptions"


const HotpairTrend = ({ index, trend, setSelectedTrendPopup, searchParams }) => {


  return <div className="relative w-screen py-1 border-b-2 mb-2">
    <div className="w-full pl-4 font-semibold text-xl text-blue-500 hover:text-blue-600 "
      onClick={() => {
        setSelectedTrendPopup(trend)
      }}
    >{((parseInt(searchParams.get('page') || '1') - 1) * (searchParams.get('limit') || '20')) + index + 1}. {trend.set1Value} {trend.set1Category} &times; {trend.set2Value} {trend.set2Category} - {trend.count}</div>
    <div className="flex w-full overflow-x-auto">
      {trend.images.map(im => <div className="h-60 px-1 w-auto shrink-0"><img src={im.imageUrl} className='h-full' /></div>)}
    </div>
    {trend.trendType != 'color' && trend.colorOptions ? <HotPairColorOptions trend={trend} /> : null}

  </div>
}

export default HotpairTrend
